import { render, staticRenderFns } from "./RefundPolicy.vue?vue&type=template&id=f116fb3e&scoped=true&"
import script from "./RefundPolicy.vue?vue&type=script&lang=ts&"
export * from "./RefundPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./RefundPolicy.vue?vue&type=style&index=0&id=f116fb3e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f116fb3e",
  null
  
)

export default component.exports